import { Outlet } from "react-router-dom";

const ReportingPageLayout = () => {
  return (
    <><Outlet /></>
  );
};

export default ReportingPageLayout;